import { Middleware } from 'redux';
import { appMounted } from '@wix/da-shared-react/pkg/redux/app/actions';

const createFedopsLogger = (logger): Middleware => {
  return api => next => action => {
    if (action.type === appMounted.toString()) {
      window.requestAnimationFrame(() => {
        logger.appLoaded();
      });
    }
    return next(action);
  };
};

export default createFedopsLogger;
